import store from '@/store';
import { local } from '@/utils/storage';
import Vue from 'vue';
import VueRouter from 'vue-router';
//MedicalAtlas

Vue.use(VueRouter);

// const routes = [
//   {
//     path: '/',
//     redirect: '/login'
//   },
//   {
//     path: '/login',
//     name: 'login',
//     component: () => import('../views/login/login.vue')
//   },
//   {
//     path: '/index',
//     component: () => import('@/layout/index.vue'),
//     children: [
//       {
//         path: '',
//         component: () => import('@/views/index/index.vue'),
//         meta: {
//           title: '首页',
//           menu: true,
//           icon: 'icon-shanxingtu',
//         }
//       },
//       {
//         path: '/indexLast',
//         component: () => import('@/views/index/indexLast.vue'),
//         meta: {
//           title: '搜索之后',
//           menu: false
//         }
//       }
//     ]
//   },

//   {
//     path: '/information',
//     component: () => import('@/layout/index.vue'),
//     children: [
//       {
//         path: '',     //  默认路由   不需路径
//         component: () => import('@/views/information/information.vue'),
//         meta: {
//           title: '信息标准文件',
//           menu: true,
//           icon: 'icon-wenjianjia',
//         }
//       },
//       {
//         path: '/previews',
//         component: () => import('@/views/preview/previews.vue'),
//         meta: {
//           title: '预览',
//           menu: false
//         }
//       }
//     ]
//   },
//   {
//     path: '/total',
//     component: () => import('@/layout/index.vue'),
//     redirect: '/total/PutWarehouse',
//     meta: {
//       title: '疾病信息元数据',
//       icon:'icon-data-update'
//     },
//     children: [
//       {
//         path: '/total/PutWarehouse',
//         component: () => import('@/views/total/PutWarehouse.vue'),
//         meta: {
//           title: '图空间',
//           menu: true,

//         }
//       },
//       {
//         path: '/total/OutWarehouse',
//         component: () => import('@/views/total/OutWarehouse.vue'),
//         meta: {
//           title: '图空间列表',
//           menu: true
//         }
//       },
//       {
//         path: '/total/SearchWarehouse',
//         component: () => import('@/views/total/SearchWarehouse.vue'),
//         meta: {
//           //title: '探索画布',
//           title: '新建主题',
//           menu: true
//         }
//       },
//       {
//         path: '/schema',
//         component: () => import('@/views/schema/schema.vue'),
//         meta: {
//           title: 'schema',
//           menu: false
//         }
//       },
//       {
//         path: '/Editschema',
//         component: () => import('@/views//Editschema/Editschema.vue'),
//         meta: {
//           title: '编辑实体',
//           menu: false
//         }
//       }
//     ]
//   },
//   {
//     path: '/medical',
//     component: () => import('@/layout/index.vue'),
//     children: [
//       {
//         path: '',
//         component: () => import('@/views/medical/MedicalAtlas.vue'),
//         meta: {
//           title: '医学图谱知识',
//           menu: true,
//           icon:'icon-qiyetupu'
//         }
//       }
//     ]
//   },
//   {
//     path: '/history',
//     component: () => import('@/layout/index.vue'),
//     redirect: '/history/SearchHistory',
//     meta: {
//       title: '系统设置',
//       icon:'icon-shezhi'
//     },
//     children: [
//       {
//         path: '/history/SearchHistory',
//         component: () => import('@/views/history/SearchHistory.vue'),
//         meta: {
//           title: '添加用户',
//           menu: true
//         }
//       },
//       {
//         path: '/history/DeliveryRecord',
//         component: () => import('@/views/history/DeliveryRecord.vue'),
//         meta: {
//           title: '角色权限',
//           menu: true
//         }
//       },
//       {
//         path: '/history/AddTissue',
//         component: () => import('@/views/history/AddTissue.vue'),
//         meta: {
//           title: '添加组织',
//           menu: false
//         }
//       }
//     ]
//   },
// ]

//静态路由
export const constantRoutes = [
  // {
  //   path: '/',
  //   redirect: '/index'
  // },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/login.vue')
  },
  {
    path: '/redirect',
    name: 'redirect',
    component: () => import('../views/redirect.vue')
  },
  {
    path: '/',
    redirect: '/index',
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/index',
        component: () => import('@/views/index/index.vue'),
        meta: {
          title: '首页',
          menu: true,
          icon: 'icon-shanxingtu',
          isShow: true //  面包屑标识
        }
      },
      {
        path: '/indexLast',
        component: () => import('@/views/index/indexLast.vue'),
        meta: {
          title: '搜索之后',
          menu: false,
          isShow: true //  面包屑标识
        }
      }
    ]
  }
];

//异步路由
export const asyncRoutes = [
  {
    path: '/information',
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '', //  默认路由   不需路径
        component: () => import('@/views/information/information.vue'),
        meta: {
          title: '信息标准文件',
          menu: true,
          icon: 'icon-wenjianjia'
        }
      },
      {
        path: '/previews',
        component: () => import('@/views/preview/previews.vue'),
        meta: {
          title: '预览',
          menu: false
        }
      }
    ]
  },
  {
    path: '/total',
    component: () => import('@/layout/index.vue'),
    redirect: '/total/PutWarehouse',
    meta: {
      title: '疾病信息元数据',
      icon: 'icon-data-update'
    },
    children: [
      {
        path: '/total/PutWarehouse',
        component: () => import('@/views/total/PutWarehouse.vue'),
        meta: {
          title: '图空间',
          menu: true
        }
      },
      {
        path: '/total/OutWarehouse',
        component: () => import('@/views/total/OutWarehouse.vue'),
        meta: {
          title: '图空间列表',
          menu: true
        }
      },
      {
        path: '/total/SearchWarehouse',
        component: () => import('@/views/total/SearchWarehouse.vue'),
        meta: {
          //title: '探索画布',
          title: '新建主题',
          menu: true
        }
      },
      {
        path: '/schema',
        component: () => import('@/views/schema/schema.vue'),
        meta: {
          title: 'schema',
          menu: false
        }
      },
      {
        path: '/Editschema',
        component: () => import('@/views//Editschema/Editschema.vue'),
        meta: {
          title: '编辑实体',
          menu: false
        }
      }
    ]
  },
  {
    path: '/medical',
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '',
        component: () => import('@/views/medical/MedicalAtlas.vue'),
        meta: {
          title: '医学图谱知识',
          menu: true,
          icon: 'icon-qiyetupu'
        }
      }
    ]
  },
  {
    path: '/history',
    component: () => import('@/layout/index.vue'),
    redirect: '/history/SearchHistory',
    meta: {
      title: '系统设置',
      icon: 'icon-shezhi',
      role: ['00', '01']
    },
    children: [
      {
        path: '/history/SearchHistory',
        component: () => import('@/views/history/SearchHistory.vue'),
        meta: {
          title: '添加用户',
          menu: true
        }
      },
      {
        path: '/history/DeliveryRecord',
        component: () => import('@/views/history/DeliveryRecord.vue'),
        meta: {
          title: '角色权限',
          menu: true
        }
      },
      {
        path: '/history/AddTissue',
        component: () => import('@/views/history/AddTissue.vue'),
        meta: {
          title: '添加组织',
          menu: true
        }
      }
    ]
  }
];

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  routes: constantRoutes
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    let obj = {
      title: to.meta.title,
      path: to.path
    };
    let topTile = store.state.tags.some(item => {
      return item.title == to.meta.title;
    });
    if (!topTile) {
      store.state.tags.push(obj);
    }
  }

  //这个仅仅是获取token和role 依据自己的存储方式获取
  // const token = store.state.token
  // const role = store.state.role
  const token = local.get('Token');
  const role = local.get('Roles');
  if (to.path === '/login' || to.path === '/redirect') {
    next();
  } else {
    if (token) {
      //从vuex中拿出计算好的路由
      const isGetUserInfo = store.state.isGetUserInfo;
      if (isGetUserInfo) {
        next();
      } else {
        try {
          // 获取用户信息 方法前面那个user是模块名 如果写在index里面就没有模块名直接方法名
          // 获取动态路由
          const accessRoutes = await store.dispatch('generateRoutes', role);
          //覆盖之前路由
          router.options.routes = [...constantRoutes, ...accessRoutes];
          //添加跳转
          accessRoutes.map(route => {
            router.addRoute(route);
          });
          //把vuex中是否有用户信息标记设置为true
          store.commit('SET_IS_GET_USERINFO', true);
          // 确保路由添加完成，这个方法是必须的
          next({ ...to, replace: true });
        } catch (error) {
          // 清除vuex中的toKen 没有存store就不需要
          // store.commit('CLEAR_USER')
          // 跳转到登录
          next({ path: '/login' });
        }
      }
    } else {
      // 跳转到登录
      next({ path: '/login' });
    }
  }
});
export default router;
